import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BlockField } from "../index";
import { List } from "../../list";
import { styled } from "../../theme";
import { useBlockComponentContext } from "../BlockComponentContext";
export const BlockList = ({ items, listStyleType, ordered, queryVariables, onCatch, }) => {
    const { Translated, Markdown } = useBlockComponentContext();
    return (_jsx(Wrapper, { children: _jsx(List, { listStyleType: listStyleType, ordered: ordered, items: items.map(({ translationKey, id, children }) => (_jsxs(_Fragment, { children: [_jsx(Translated, { render: ({ translation }) => _jsx(Markdown, { source: translation }), translationKey: translationKey }, id), Array.isArray(children) &&
                        children.map(block => (_jsx(BlockField, { block: block, queryVariables: queryVariables, onCatch: onCatch }, block.id)))] }))) }) }));
};
BlockList.defaultProps = {
    ordered: false,
};
const Wrapper = styled.div `
  margin: 15px 0;

  li p,
  li span,
  li input,
  li label {
    font-size: 1em;
  }
`;
